import httpClient from "@/plugins/axios";

// Page Categories API
export const getPageCategories = async () => {
    const response = await httpClient.get('/admin/v1/page-categories/');
    return response;
}

export const getPageCategory = async (id) => {
    const response = await httpClient.get(`/admin/v1/page-categories/${id}/`);
    return response;
}

export const savePageCategory = async (category) => {
    if (category.id) {
        return await httpClient.put(`/admin/v1/page-categories/${category.id}/`, category);
    }
    return await httpClient.post('/admin/v1/page-categories/', category);
}

export const sortPageCategories = async (sortedIds) => {
    const response = await httpClient.post('/admin/v1/page-categories/sort/', sortedIds);
    return response;
}

export const deletePageCategory = async (id) => {
    const response = await httpClient.delete(`/admin/v1/page-categories/${id}/`);
    return response;
}

// Pages API
export const getPages = async (categoryId = null) => {
    const url = categoryId
        ? `/admin/v1/pages/?category=${categoryId}`
        : '/admin/v1/pages/';
    const response = await httpClient.get(url);
    return response;
}

export const getPage = async (id) => {
    const response = await httpClient.get(`/admin/v1/pages/${id}/`);
    return response;
}

export const getPageGroups = async (id) => {
    const response = await httpClient.get(`/admin/v1/pages/${id}/groups/`);
    return response;
}

export const sort = async (sortedIds) => {
    const response = await httpClient.put('/admin/v1/pages/sort/', sortedIds);
    return response;
}

export const savePage = async (page, parentPage, newImage, newImageName, removeImage, category = null) => {
    const formData = getFormData(page, parentPage, newImage, newImageName, removeImage, category);
    if (page.id) {
        return await updatePage(page.id, formData);
    }
    else {
        return await insertPage(formData);
    }
};

const insertPage = async (formData) => {
    const response = await httpClient.post('/admin/v1/pages/?html=true', formData)
    return response;
}

const updatePage = async (id, formData) => {
    const response = await httpClient.put(`/admin/v1/pages/${id}/?html=true`, formData);
    return response;
}

export const deletePage = async (id) => {
    const response = await httpClient.delete(`/admin/v1/pages/${id}/`)
    return response;
}

export const savePageAttachment = async (pageId, file, langCode) => {
    const formData = new FormData();
    formData.append("file", file);
    if (langCode) {
        formData.append("language", langCode);
    }
    const response = await httpClient.post(`/admin/v1/pages/${pageId}/attachments/`,
        formData
    );
    return response;
}

export const sortPageAttachments = async (pageId, attachmentIds) => {
    const response = await httpClient.put(`/admin/v1/pages/${pageId}/attachments/sort/`,
        attachmentIds
    );
    return response;
}

export const downloadPageAttachment = async (pageId, attachmentId) => {
    const response = await httpClient.get(`/admin/v1/pages/${pageId}/attachments/${attachmentId}/?admin_view=1`,
        {
            responseType: 'blob',
        }
    );
    return response;
}

export const removePageAttachment = async (pageId, attachmentId) => {
    const response = await httpClient.delete(`/admin/v1/pages/${pageId}/attachments/${attachmentId}/?admin_view=1`);
    return response;
}


const getFormData = (page, parentPage, newImageBlob, newImageName, removeImage, category = null) => {
    const formData = new FormData()
    if (page.id)
        formData.append('id', page.id);
    formData.append('published', page.published);
    formData.append('translations', JSON.stringify(page.translations));
    formData.append('require_acknowledgment', page.require_acknowledgment);
    formData.append('acknowledgment_version', page.acknowledgment_version);

    page.groups.forEach(g => {
        formData.append('groups', g);
    });

    if (parentPage) {
        formData.append('parent_page', parentPage);
    }

    if (category) {
        formData.append('category', category);
    }

    if (newImageBlob) {

        formData.append('image', newImageBlob, newImageName);
    } else if (removeImage) {
        formData.append('remove_image', true)
    }

    if (page.videoUrl) {
        formData.append('video_url', page.videoUrl)
    }

    return formData;
}
